import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from './App';
import 'ant-design-vue/dist/reset.css';
import '@assets/styles/common.css';
import '@assets/styles/reset.css';
import router from '@/router'
import i18n from '@/language/i18n';


const app = createApp(App);

app.use(i18n).use(router).use(Antd).mount('#app');